// @flow
import React, { Component } from "react";
import { Document, Page } from "react-pdf";
import I18n from "../../../i18n/I18n";
import styles from "./Preview.scss";

class Preview extends Component {
  state = {
    numPages: null,
    pageNumber: 1
  };

  onDocumentLoad = ({ numPages }) => {
    this.setState({ numPages });
  };

  getFileExtension1(filename) {
    return filename
      ? filename.slice(((filename.lastIndexOf(".") - 1) >>> 0) + 2)
      : "";
  }

  render() {
    const { pageNumber } = this.state;
    const { vatFile } = this.props;
    return (
      <div className={styles.ctr}>
        <div className={styles.imgCtr}>
          {this.getFileExtension1(vatFile) !== "pdf" ? (
            <img className={styles.previewImage} src={vatFile} alt="preview" />
          ) : (
            <Document
              file={`https://cors-anywhere.herokuapp.com/${vatFile}`}
              onLoadSuccess={this.onDocumentLoad}
              loading={I18n.getText(
                "settings.preview-loading-text",
                {},
                "Please wait while we load you document"
              )}
            >
              <Page pageNumber={pageNumber} />
            </Document>
          )}
        </div>
      </div>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/settings/uploadView/Preview.js